import Form from 'app/components/Form';

import {
  createMoment,
  updateMoment
} from 'app/services/moments';

import {
  getJobs
} from 'app/services/jobs';

import {
  formatOptions
} from 'app/utils/options';

const MomentForm = props => {
  const {
    moment,
    onClose,
    agGrid,
    action
  } = props;

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  const getJobOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    // using getJobs from app/services/jobs instead of app/actions/jobs
    // to avoid setting the results in redux.
    // this API call is just for the autocomplete filter
    let params = {
      page,
      per_page: perPage
    }

    if (filter) {
      params.filter_model = {
        name: [{
          filterClass: 'text',
          filterType: 'contains',
          value: filter
        }]
      }
    }

    if (id) {
      params.filter_model = {
        id: [{
          filterClass: 'text',
          filterType: 'equals',
          value: id.toString()
        }]
      }
    }

    let resp = await getJobs(params);
    return formatOptions(resp.records);
  }

  let fields = [
    { name: 'job_id', label: 'Job', type: 'autocomplete', value: moment?.job_id, valueType: 'integer', getOptions: getJobOptions }
  ]

  // handle form submit
  const onSubmit = async params => {
    if (action === 'update') {
      let updatedMoment = await updateMoment(moment.id, params);
      agGrid.updateRow(updatedMoment);
    } else {
      // createMoment currently calls POST /portal/moment
      // but doesn't pass the right params to do anything.
      // instead of a New Moment form we'll probably want
      // an Upload Moments form
      let notImplemented = true;
      if (notImplemented) {
        throw 'Not implemented';
      }

      await createMoment(params);
      onClose();
      agGrid.refreshGrid();
    }
  }

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default MomentForm;
